<template>
  <div v-loading="loading"
       class="dashboard-area">
    <div class="flex size14 align-center notice-area-title">
      <i class="iconfont icongonggao"></i>
      <span class="size14 area-tit">公告</span>
    </div>

    <gj-radio-group
        v-model="activeType"
        :options="[
                  {id: '1', text: '广告推荐'},
                  {id: '2', text: '系统更新'}
              ]"
        style="margin-bottom: 12px"
    ></gj-radio-group>

      <el-carousel height="527px" v-show="activeType==='1'" indicator-position="outside" :interval="5000">
        <el-carousel-item v-for="item in bannerList" :key="item.id">
          <div style="height: 100%;">

            <el-image style="width: 100%;height: 100%;" :src="item.bannerUrl" v-if="item.bannerType.code === 'PICTURE'" fit="contain"></el-image>

            <video style="width: 100%;height: 100%;" :src="item.bannerUrl" v-if="item.bannerType.code === 'VIDEO'" controls>
              您的浏览器不支持播放视频，请使用谷歌浏览器！
            </video>

          </div>
        </el-carousel-item>
      </el-carousel>

    <div class="notice-wrapper" v-show="activeType==='2'">
      <template v-if="data && data.length > 0">
        <div v-for="(item, i) in data"
             :key="i"
             class="notice flex justify-center">
          <div class="flex align-center justify-between" style="margin-bottom: 4px;">
            <div class="flex align-center">
              <div class="gj-dot" :class="{'isRead':item.isRead}"></div>
              <gj-link
                  style="font-weight: 600;"
                  type="default"
                  @click="openNoticeModal(item)">
                {{item.title}}
              </gj-link>
            </div>
            <div class="notice-time color666">{{item.releaseTime}}</div>
          </div>
          <div class="color666 text-ellipsis-1 notice-content">{{item.releaseDesc}}</div>
        </div>
      </template>
      <template v-else>
        <gj-empty></gj-empty>
      </template>
    </div>

  </div>
</template>

<script>
import {getSystemNotice, sysBanner} from "../../../../../api/dashboard";
  import {isMeaningful} from "../../../../../utils/common";
  import AppVersionAnnouncementModal from "../../../common/message/modal/version-announcement";
  import {newVersion} from "../../../../../api/message";
import {USER_SET_LATEST_VERSION_ID} from "@/store/mutation-types";
  
  export default {
    name: "app-dashboard-notice",
    data() {
      return {
        activeType: '1',
        data: [],
        loading: false,
        bannerList: []
      }
    },
    created() {
      this.data = [];
      this.loading = true;
      getSystemNotice({
        model: {},
        current: 1,
        size: 20,
        sort: "releaseTime",
        order: "descending"
      })
        .then((data) => {
          if (isMeaningful(data)) {
            this.data = data.records;
            this.data.forEach(r=>{
              if(isMeaningful(r.content)) {
                r.content = r.content.replace(/<\/?.+?\/?>/g,'')
              }
            })
            this.$store.commit(USER_SET_LATEST_VERSION_ID, this.data[0].id);
          }
        })
        .complete(() => this.loading = false);
      sysBanner().then(data=>{
        this.bannerList = data
      })
    },
    methods: {
      openNoticeModal(row) {
        newVersion(row.id, !row.isRead).then((res) => {
          this.$gjCreate(AppVersionAnnouncementModal, {
            global: true,
            props: {
              data: res.data
            }
          })
          row.isRead = true
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import "../common";
  .dashboard-area{
    height: 641px;
    box-sizing: border-box;
    padding-top: 12px;
  }
  .notice-wrapper {
    height: 548px;
    overflow: auto;
    //border-top: 1px solid #e8e8e8;
  }
  .notice {
    border-bottom: 1px dashed #e8e8e8;
    height: 60px;
    font-size: 12px;
    padding-left: 8px;
    padding-right: 10px;
    flex-direction: column;
  }
  .notice-time {
    margin-left: 20px;
  }
  .notice-content{
    padding-left: 10px;
  }
  .gj-dot{
    margin-right: 4px;
  }
  .isRead{
    background-color: #D8DADD;
  }
  .gj-empty {
    height: 250px;
    width: 250px;
    margin: 40px auto 0;
  }
  .notice-area-title{
    margin-bottom: 8px;
    line-height: 22px;
  }
  /deep/ .el-radio-button__inner{
    padding: 4px 16px;
  }
  /deep/ .el-carousel__indicator--horizontal{
    padding: 0;
  }
</style>
